/**
 * in this module the are all the function to create the invmap popup that include:
 *  - hover popup
 *  - click popup
 */
 import functions from '../common/functions'
 import {XMLParser, XMLValidator} from 'fast-xml-parser'

 var pageconfig = JSON.parse($('#pageconfig').val())
 let popupconfig = JSON.parse($('#popupconfig').val())
 let myitemsLength = 0
/**
 * global vars
 */

// temporary arrays for the creation of the popup
let tempContent = []
let tempTitle = []
let popBtnArray = []
let popContentArray = []
// temporary array for the creation of the hover popup

/**
 * build the popup content
 * full popup for TRO
 * we need to pass fixed, getSettings, xml, mousePos, overlay
 */

const fullInfo = (xml, overlay) => {
  /**
   * assign the popupname value
   * assign the overlay value
   */

   let popupname = pageconfig.layers[0].popupname
   /**
    * get the result from the XML
    * - create a parser
    * - parse the result
    * - get the item element
    * - get the length of the item element
    */

    let myitems = xml.getElementsByTagName('item')
    myitemsLength = myitems.length

  /**
   * initilaize some variable to use it in the process
   */

  let conterz = ''
  let infoDiv = ''
  tempContent = []
  tempTitle = []
  popBtnArray = []
  popContentArray = []
  /**
   * get the popup container
   *  - normal popup
   *  - mobile popup
   */

  let content = document.getElementById('popup-content')
  let modalpop = document.getElementById('mobpopupbody')
  content.innerHTML = ''//blank content doenst seem to work always from popup
  /**
   * other variables used in the process
   */

  /**
   * if there is no result or is a moving sign return
   */

  if (myitems.length === 0) {
    return
  }

  /**
   * iterate through the result
   */

  for (let i = 0; i < myitemsLength; i++) {

    if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Invmap') {
      /**
       * parse the xml into a json file with fast-xml-parser that is installed as a dependency
       * https://www.npmjs.com/package/fast-xml-parser
       * this is because IE 11 doesn't like to iterate through xml that you don't know the tagname
       */

      let InvParser = new XMLParser()
      var options = {
        ignoreAttributes : true,
        ignoreNameSpace : false,
        allowBooleanAttributes : true,
        parseNodeValue : true,
        parseAttributeValue : false,
        trimValues: true,
        decodeHTMLchar: true,
        cdataTagName: false
      }

      let jsonObjInv
      let xmlString = (new XMLSerializer()).serializeToString(xml)
      if(XMLValidator.validate(xmlString)){
         jsonObjInv = InvParser.parse(xmlString, options)
      }
      else {
        let tObj = InvParser.getTraversalObj(xmlString, options)
        jsonObjInv = InvParser.convertToJson(tObj, options)
      }

      /**
       * for each key value of the object add it to the popup
       * if the key is inv_table append the View documents... button and call the function invmapdocs
       * if the key is typeid or inv_num continue
       * else append the key value to the popup and use the function functions.capitalLetter() for the key
       */
      if (jsonObjInv.twfeatures.item.length) {
        Object.keys(jsonObjInv.twfeatures.item[i]).forEach(function (key) {
          if (key === 'inv_table') {
            conterz += `<div style='padding:5px 10px;'><button class='btn infotitle invDoc d-none'>${popupconfig.invmap_popup.viewdocuments}</button><ul class='invdoclist d-none'></ul></div>`
            invmapdocs(myitems[i].getElementsByTagName('inv_num')[0].firstChild.nodeValue, myitems[i].getElementsByTagName('inv_table')[0].firstChild.nodeValue)
          }
          else {
            if (key === 'typeid' || key === 'inv_num') {
            }
            else {
              conterz += `<div><span class='infotitle'>${functions.capitalLetter(key.replace(/_/g, ' '))}: ${jsonObjInv.twfeatures.item[i][key]}</span></div>`
            }
          }
        })
      }
      else {
        for (let key in jsonObjInv.twfeatures.item) {
          if (key === 'inv_table') {
            conterz += `<div style='padding:5px 10px;'><button class='btn infotitle invDoc d-none'>View Documents...</button><ul class='invdoclist d-none'></ul></div>`
            invmapdocs(myitems[i].getElementsByTagName('inv_num')[0].firstChild.nodeValue, myitems[i].getElementsByTagName('inv_table')[0].firstChild.nodeValue)
          }
          else {
            if (key === 'typeid' || key === 'inv_num') {
            }
            else {
              conterz += `<div><span class='infotitle'>${functions.capitalLetter(key.replace(/_/g, ' '))}: ${jsonObjInv.twfeatures.item[key]}</span></div>`
            }
          }
        }
      }

    /**
     * end invmap popup
     */
    }




    /**
     * else for every other type
     */

    else {
      if (myitems[i].attributes.getNamedItem('type').nodeValue === 'site') {
        conterz += `<div><span class='infotitle'>${popupconfig.invmap_popup.site}: ${functions.getFieldValue(myitems, i, 'sitename')}</div>`
      }
      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'camera') {
        conterz += `<div><span class='infotitle'>${popupconfig.invmap_popup.camera}: ${functions.getFieldValue(myitems, i, 'name')}</div>`
      }
      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones') {
        conterz += `<div><span class='infotitle'>${popupconfig.invmap_popup.zone}: ${functions.getFieldValue(myitems, i, 'polyname')}</div>`
      }
      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
        conterz += `<div><span class='infotitle'>${popupconfig.invmap_popup.property}: ${functions.getFieldValue(myitems, i, 'property')}</div>`
     }
      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'accident') {
        conterz += `<div><span class='infotitle'>${popupconfig.invmap_popup.accident}: ${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}: ${functions.getFieldValue(myitems, i, 'severity')}</div>`
      }
      else {
        conterz += `<div><span class='infotitle'>${popupconfig.invmap_popup.restriction}: ${functions.getFieldValue(myitems, i, 'restriction')}</div>`
      }
    }

    if (i === 0) {
      infoDiv =  `<div id='info_${i}'>${conterz}</div>`
    }
    else {
      infoDiv =  `<div id='info_${i}' style='display:none;'>${conterz}</div>`
    }
    /**
     * insert the content of the popup in a temporary array
     */

    tempContent.push(infoDiv)

    /**
     * insert the title in a temporary array
     * check for each type
     */

    if (myitems[i].attributes.getNamedItem('type').nodeValue === 'site') {
      tempTitle.push((`${popupconfig.invmap_popup.site}: ${functions.getFieldValue(myitems, i, 'sitename')}`))
    }
    else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'camera') {
      tempTitle.push((`${popupconfig.invmap_popup.camera}: ${functions.getFieldValue(myitems, i, 'name')}`))
    }
    else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones') {
      tempTitle.push((`${popupconfig.invmap_popup.zone}: ${functions.getFieldValue(myitems, i, 'polyname')}`))
    }
    else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
      tempTitle.push((`${popupconfig.invmap_popup.property}: ${functions.getFieldValue(myitems, i, 'property')}`))
   }
    else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'accident') {
      tempTitle.push((`${popupconfig.invmap_popup.accident}: ${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}: ${functions.getFieldValue(myitems, i, 'severity')}`))
    }
    else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Invmap') {
      tempTitle.push((`${popupconfig.invmap_popup.invmap}: ${myitems[i].getElementsByTagName('inv_type')[0].firstChild.nodeValue}`))
    }
    else {
      tempTitle.push((`${popupconfig.invmap_popup.restriction}: ${functions.getFieldValue(myitems, i, 'restriction')}`))
    }

    /**
     * reset the conterz var as now is inside the infoDiv var
     */

    conterz = ''
  } // next feature

  /**
   * common code for all popups
   */

  /**
   * as we push every time the previous content we need to filter the final popup
   */

  const removeDuplicates = (arr) => {
    var uniqueArray = []
    for (let x = 0; x < arr.length; x++) {
      if (uniqueArray.indexOf(arr[x]) === -1) {
        uniqueArray.push(arr[x])
      }
    }
    return uniqueArray.join(' ')
  }

  /**
   * create the content of every popup(button + content)
   */

  for (let j = 0; j < tempTitle.length; j++) {
    var btn = `<li value='${j}' class='itemlist resetorder order_${j}' id='listitem_${j}'>${tempTitle[j]}</li>`

   //ORIGINAL var btn = `<div><button id='popitembutton_${j}' class='btn btnlistmain'>${tempTitle[j]}</button><div class='btn${j} d-none'>${tempContent[j]}</div></div>`
    var cont = tempContent[j]
    popContentArray.push(cont)
    popBtnArray.push(btn)
  }
  /**
   * check for the screen resolution
   */

  if (functions.mobileTabletView()) {
    /**
     * if is mobile append the content of the popup to the modal used for the popup
     * display the modal
     */

    if (myitemsLength > 1) {
        modalpop.innerHTML = `<div><button id='itembutton' class='custbtn'></button><div id='itemdiv' style='display:none'><ul id='itemlist'>${removeDuplicates(popBtnArray)}</ul></div></div><input type='hidden' id='numofdivs' value='${myitemsLength}'/>${removeDuplicates(popContentArray)}`
    } else {
        modalpop.innerHTML = `<input type='hidden' id='numofdivs' value='${myitemsLength}'/>${removeDuplicates(popContentArray)}`
    }
    $('#mobpopup').modal('show')
  }

  /**
   * if is a tablet or a pc append the content of the popup to the popup div
   * display the popup
   */

  else {

    if (myitemsLength > 1) {
        content.innerHTML = `<div><button id='itembutton' class='custbtn'></button><div id='itemdiv' style='display:none'><ul id='itemlist'>${removeDuplicates(popBtnArray)}</ul></div></div><input type='hidden' id='numofdivs' value='${myitemsLength}'/>${removeDuplicates(popContentArray)}`
    } else {
        content.innerHTML = `<input type='hidden' id='numofdivs' value='${myitemsLength}'/>${removeDuplicates(popContentArray)}`
    }
  }

  /**
   * remove the class d-none from btn0 (it's the first content of the first button) in the popup
   * apply the css overflow hidden to mobpopupbody
   */

  $('.btn0').removeClass('d-none')
  $('#mobpopupbody').css('overflow', 'hidden')

  /**
   * check if the children of the popup content (mobile and desktop is more than 1)
   * display the first button in order to have all buttons
   * or hide it if it's just one element
   */

  if ($('#popup-content').children().length > 1 || $('#mobpopupbody').children().length > 1) {
    $('#popitembutton_0').removeClass('d-none')
  }
  else {
    $('#popitembutton_0').addClass('d-none')
  }


  setInfoControls(overlay)
  /**
   * hide or show the list on click in the button
   */

  $('.invDoc').on('click', function () {
    $('.invdoclist').toggleClass('d-none')
  })

/**
 * end const fullInfo = (fixed, getPmSettings, xml, mousePos, getOverlay) => {
 */
}

/**
 * get invmap documents
 */

const invmapdocs = (invmapId, invmapTable) => {
  /**
   * check if it's a development or a live system
   * populate the url accordingly
   */

  /**
   * run an ajax request
   */
   let theData = '{"invref": "'+ invmapId +'","invtab": "'+ invmapTable +'"}'
   // if docstore_sinfodiv already exisitngs then return!


     /**
    * get the json for mapscheds and docs
    */
    $.ajax({
     url: '/invmapdocs',
     type:"POST",
     data: {
       jdata: theData
     },
     beforeSend: function beforeSend(xhr) {
       xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
     },
     success:function(data){

         /**
        * check if the type of data.documents is not undefines
        */

       if (typeof data.documents === 'undefined') {
         // return
       }
       else {
         /**
          * for each item create the list
          * add the click event
          */

         $.each(data.documents, function () {
           let orderDocs = this
           let theDocItem = $(`<li>${orderDocs.doc_path.split('/')[2]}</li>`).attr('docname', orderDocs.doc_path).click(function () {
             let theDoc = $(this).attr('docname')
             window.open(theDoc)
           })
           /**
            * append the item to .invdoclist
            */
           $('.invdoclist').append(theDocItem)
         })

         $('.invDoc').removeClass('d-none')
       }
        /**
         * end done Ajax
         */
     }
    })
}

/**
 * if you click on multiple restrictions show all the available restrictions
 */

 const setInfoControls = (getOverlay) => {
  /**
   * initialize the overlay
   */

  let overlay = getOverlay
  /**
   * get the text from the listitem_0
   * change the text of itembutton
   * prepend the arrow to the text
   */

  const theButt = $('#listitem_0').text()

  $('#itembutton').text(theButt)
  $('#itembutton').prepend("<em class='itmbtnlist fas fa-caret-right'></em>")

  /**
   * itembutton click event listener
   */

  $('#itembutton').click(function () {
    /**
     * show/hide the list of available restrictions
     * change the arrow accordingly
     */

    $('#itemdiv').slideToggle()
    $(this).children('em').toggleClass('fa-caret-right fa-caret-down')
  })

  /**
   * itemlist click event listener
   */

  $('.itemlist').click(function (e) {
    /**
     * prevent default behaviour
     */

    e.preventDefault()

    /**
     * get the value from the this item
     * get the text from the listitem_
     * change the text of itembutton
     * prepend the arrow to the text
     * show/hide the list of available restrictions
     */

    let theVal = this.value
    const theButts = $(`#listitem_${theVal}`).text()
    $('#itembutton').text(theButts)
    $('#itembutton').prepend("<em class='itmbtnlist fas fa-caret-right'></em>")
    $('#itemdiv').slideToggle()

    /**
     * change the displayed popup content
     */

    changeInfoItem(theVal)

    /**
     * end itemlist click event listener
     */
  })

  /**
   * end setInfoControls
   */
}

/**
 * change the displayed popup content
 */

const changeInfoItem = (sInfoDiv) => {
  /**
   * initialize numofdivs
   * change the numofdivs to the number of element inside numofdivs
   * assign to num the lenght of numofdivs - 1 to itemLength
   */

  let numofdivs = 0
  numofdivs = parseInt(document.getElementById('numofdivs').value)
  let itemLength = numofdivs - 1

  /**
   * initialize numofdivs
   * change the numofdivs to the number of element inside numofdivs
   * assign to num the lenght of numofdivs - 1 to itemLength
   */

  for (let l = 0; l <= itemLength; l++) {
    /**
     * check if #info_ l match info_ sInfoDiv
     */

    if (document.getElementById(`info_${l}`).id === (`info_${sInfoDiv}`)) {
      /**
       * display info_ sInfoDiv
       */

      $(`#info_${sInfoDiv}`).css('display', 'block')
    }
    /**
     * if #info_ l don't match info_ sInfoDiv
     */

    else {
      /**
       * hide info_ l
       */

      $(`#info_${l}`).css('display', 'none')
    }

    /**
     * end for loop
     */
  }

  /**
   * end const changeInfoItem = (sInfoDiv) =>
   */
}


/**
 * EXPORT
 */

export default {
  fullInfo
}
